export default [
  {
    id: "1",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike1.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike1.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike1_1.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike1_2.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike1_3.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike1_4.png",
    ],
    name: "Wild Berry",
    price: 160,
    sizes: [39, 40, 41],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "2",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike2.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike2.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike2_1.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike2_2.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike2_3.png",
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike2_4.png",
    ],
    name: "Air Force 1",
    price: 169,
    sizes: [39, 40, 41, 42, 43],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "3",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike3.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike3.png",
    ],
    name: "Nike Cosmic",
    price: 129,
    sizes: [38, 39, 40, 41, 42],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "4",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike4.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike4.png",
    ],
    name: "Retro High",
    price: 119,
    sizes: [39, 40, 41, 42, 45],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "5",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike5.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike5.png",
    ],
    name: "Pegas Turbo",
    price: 95,
    sizes: [36, 40, 41, 42, 47],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "6",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike6.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike6.png",
    ],
    name: "Nike Blazer",
    price: 200,
    sizes: [37, 38, 40, 41, 42],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "7",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike7.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike7.png",
    ],
    name: "Nike Waffle",
    price: 154,
    sizes: [39, 40, 41],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "8",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike8.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike8.png",
    ],
    name: "Nike Reax",
    price: 123,
    sizes: [40, 41, 42],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "9",
    image: "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike9.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike9.png",
    ],
    name: "Nike Dunk",
    price: 119,
    sizes: [40, 41, 42, 43, 44],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.

Advantages:
- Encapsulated Air-Sole unit for lightweight cushioning.
- Genuine leather on the upper for durability and a premium look.
- Solid rubber outsole for greater traction on different types of surfaces.
- Color Shown: Palomino/White/Wild Berry
- Model: 553558-215
- Proven efficacy

A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "10",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike10.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike10.png",
    ],
    name: "Nike Air Penny",
    price: 149,
    sizes: [37, 40, 41, 42],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
  
  Advantages:
  - Encapsulated Air-Sole unit for lightweight cushioning.
  - Genuine leather on the upper for durability and a premium look.
  - Solid rubber outsole for greater traction on different types of surfaces.
  - Color Shown: Palomino/White/Wild Berry
  - Model: 553558-215
  - Proven efficacy
  
  A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "11",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike11.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike11.png",
    ],
    name: "Court Vision",
    price: 132,
    sizes: [39, 41, 42],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
  
  Advantages:
  - Encapsulated Air-Sole unit for lightweight cushioning.
  - Genuine leather on the upper for durability and a premium look.
  - Solid rubber outsole for greater traction on different types of surfaces.
  - Color Shown: Palomino/White/Wild Berry
  - Model: 553558-215
  - Proven efficacy
  
  A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "12",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike12.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike12.png",
    ],
    name: "Nike Immortality",
    price: 88,
    sizes: [39, 40, 41, 45],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
    
    Advantages:
    - Encapsulated Air-Sole unit for lightweight cushioning.
    - Genuine leather on the upper for durability and a premium look.
    - Solid rubber outsole for greater traction on different types of surfaces.
    - Color Shown: Palomino/White/Wild Berry
    - Model: 553558-215
    - Proven efficacy
    
    A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "13",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike13.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike13.png",
    ],
    name: "Nike Aura",
    price: 201,
    sizes: [39, 41, 42, 45],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
    
    Advantages:
    - Encapsulated Air-Sole unit for lightweight cushioning.
    - Genuine leather on the upper for durability and a premium look.
    - Solid rubber outsole for greater traction on different types of surfaces.
    - Color Shown: Palomino/White/Wild Berry
    - Model: 553558-215
    - Proven efficacy
    
    A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "14",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike14.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike14.png",
    ],
    name: "Nike Zoom",
    price: 104,
    sizes: [39, 41, 42, 43, 46],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
    
    Advantages:
    - Encapsulated Air-Sole unit for lightweight cushioning.
    - Genuine leather on the upper for durability and a premium look.
    - Solid rubber outsole for greater traction on different types of surfaces.
    - Color Shown: Palomino/White/Wild Berry
    - Model: 553558-215
    - Proven efficacy
    
    A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "15",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike15.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike15.png",
    ],
    name: "Nike Delta",
    price: 128,
    sizes: [39, 41, 42, 46],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
    
    Advantages:
    - Encapsulated Air-Sole unit for lightweight cushioning.
    - Genuine leather on the upper for durability and a premium look.
    - Solid rubber outsole for greater traction on different types of surfaces.
    - Color Shown: Palomino/White/Wild Berry
    - Model: 553558-215
    - Proven efficacy
    
    A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
  {
    id: "16",
    image:
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike16.png",
    images: [
      "https://notjustdev-dummy.s3.us-east-2.amazonaws.com/nike/nike16.png",
    ],
    name: "Nike React",
    price: 157,
    sizes: [39, 41, 43, 45, 46],
    description: `Inspired by the original that debuted in 1985, the Air Jordan 1 Low delivers a clean, classic look that's familiar yet fresh. With an iconic design that blends seamlessly with any fit, these shoes are perfect for taking charge.
    
    Advantages:
    - Encapsulated Air-Sole unit for lightweight cushioning.
    - Genuine leather on the upper for durability and a premium look.
    - Solid rubber outsole for greater traction on different types of surfaces.
    - Color Shown: Palomino/White/Wild Berry
    - Model: 553558-215
    - Proven efficacy
    
    A timeless rubber sole combines with a soft sockliner and encapsulated Nike Air cushioning for all-day comfort. The rubber outsole offers durable traction on a variety of surfaces.`,
  },
];
